import { memo } from 'react'

import { useTranslation } from 'react-i18next'

import { Header } from '@shared/components/Header'
import { Tabs } from '@shared/components/MaterialUIEnhancements/Tabs'
import { Content } from '@shared/layouts'
import { NavigationTabLink } from 'components/LinkedMUIComponents/NavigationTabLink'
import { audioRoute } from 'pages/NWPlatform/Workspaces/Workspace/Audio/Routing'

const StructureRaw = () => {
  const { t } = useTranslation(['common', 'pages', 'entity'])

  return (
    <Content
      HeaderSlot={
        <Header
          title={t('pages:Workspace.AudioContent.title')}
          disabled
          TabNavigation={
            <Tabs>
              <NavigationTabLink
                from={audioRoute.fullPath}
                to="/organizations/$organizationId/environments/$environmentId/workspaces/$workspaceId/audios/streams"
              >
                {t('pages:Workspace.AudioContent.streams')}
              </NavigationTabLink>
              <NavigationTabLink
                from={audioRoute.fullPath}
                to="/organizations/$organizationId/environments/$environmentId/workspaces/$workspaceId/audios/objects"
              >
                {t('pages:Workspace.AudioContent.objects')}
              </NavigationTabLink>
            </Tabs>
          }
        />
      }
    />
  )
}

export const Structure = memo(StructureRaw)
